<script setup lang="ts">
export type BasicImage = {
  image: unknown
  aspectMobile?: number
  aspectDesktop?: number
  sizes?: string
  width?: number
  height?: number
  alt?: string
  rounded?: boolean
}

const { aspectMobile = 1, aspectDesktop = 1 } = defineProps<BasicImage>()

const aspect = ref(aspectDesktop)

const updateAspect = () => {
  aspect.value = window.innerWidth < 900 ? aspectMobile : aspectDesktop
}

const _containerStyle = computed(() => ({
  aspectRatio: aspect.value,
}))

onMounted(() => {
  updateAspect()
  window.addEventListener('resize', updateAspect)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateAspect)
})

const showMediaCaption = inject('showMediaCaption', false)
</script>

<template>
  <figure v-if="image.caption && showMediaCaption" class="!h-auto w-full">
    <NuxtImg
      v-if="image"
      :src="image?.asset?._ref"
      auto="format"
      :alt="alt || image?.alt || image?.asset?._ref"
      :width="width"
      :height="height"
      fit="cover"
      :sizes="sizes"
      :modifiers="{
        crop: image?.crop,
        hotspot: image?.hotspot,
      }"
      class="h-full w-full object-cover transition-all duration-700 ease-out [&[data-placeholder-loaded=false]]:scale-105 [&[data-placeholder-loaded=false]]:blur-xl"
      loading="lazy"
      :class="rounded ? 'overflow-clip rounded-sm' : ''"
      :style="{
        objectPosition: image?.hotspot
          ? `${image.hotspot.x * 100}% ${image.hotspot.y * 100}%`
          : 'center',
      }"
    />
    <figcaption
      class="block pt-2 text-left text-base text-(--theme-fg)"
      :class="showMediaCaption ? 'block' : 'hidden'"
    >
      {{ image.caption }}
    </figcaption>
  </figure>
  <figure v-else class="w-full" :class="rounded ? 'rounded-sm' : ''">
    <NuxtImg
      v-if="image"
      :src="image?.asset?._ref"
      auto="format"
      :alt="alt || image?.alt || image?.asset?._ref"
      :width="width"
      :height="height"
      fit="cover"
      :sizes="sizes"
      :modifiers="{
        crop: image?.crop,
        hotspot: image?.hotspot,
      }"
      class="h-full w-full object-cover transition-all duration-700 ease-out [&[data-placeholder-loaded=false]]:scale-105 [&[data-placeholder-loaded=false]]:blur-xl"
      loading="lazy"
      :style="{
        objectPosition: image?.hotspot
          ? `${image.hotspot.x * 100}% ${image.hotspot.y * 100}%`
          : 'center',
      }"
    />
  </figure>
</template>
